import { app } from '../../../bootstrap/core';
import { historyComponent } from './history.component';
import { HistoryService } from './history.service';
import {
  TicketEventIcons,
  DocumentTypeDetection,
  HistoryDisplayMode,
  HistoryEventDateFormat,
  HistoryEventTimeFormat,
  HistoryEventDetailsSplitter
} from './history.constants';
import historyEventNameTemplate from './partials/history.eventName.tpl.html';
import historyTimeTemplate from './partials/history.time.tpl.html';
import './historyEntryTitle/historyEntryTitle';
import './historyEntryList/historyEntryList';

app.component('history', historyComponent);
app.service('historyService', HistoryService);
app.constant('TicketEventIcons', TicketEventIcons);
app.constant('DocumentTypeDetection', DocumentTypeDetection);
app.constant('HistoryDisplayMode', HistoryDisplayMode);
app.constant('HistoryEventDateFormat', HistoryEventDateFormat);
app.constant('HistoryEventTimeFormat', HistoryEventTimeFormat);
app.constant('HistoryEventDetailsSplitter', HistoryEventDetailsSplitter);
app.value('historyEventNameTemplate', historyEventNameTemplate);
app.value('historyTimeTemplate', historyTimeTemplate);
